import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'Industries', path: '/industries' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
];

const serviceLinks = [
  { name: 'Freight Brokerage', path: '/services#freight-brokerage' },
  { name: 'Equipment Transport', path: '/services#equipment' },
  { name: 'Port & Export Coordination', path: '/services#port' },
];

const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Instagram, href: '#', label: 'Instagram' },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy-900 border-t border-navy-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 lg:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <div className="flex flex-col">
                <span className="font-heading text-2xl sm:text-3xl font-extrabold text-white tracking-tight leading-none">
                  SUMMIT
                </span>
                <span className="font-body text-xs font-semibold text-orange-500 tracking-widest">
                  TRANSPORT & LOGISTICS
                </span>
              </div>
            </Link>
            <p className="font-body text-slate-400 text-sm leading-relaxed">
              Nationwide freight brokerage with a commitment to reliability, transparency, and getting your cargo where it needs to be.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 rounded-full bg-navy-800 flex items-center justify-center text-slate-400 hover:bg-orange-500 hover:text-white transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-bold text-white uppercase mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-slate-400 hover:text-orange-500 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-bold text-white uppercase mb-6">Services</h3>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-sm text-slate-400 hover:text-orange-500 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg font-bold text-white uppercase mb-6">Contact</h3>
            <div className="space-y-4">
              <div>
                <a
                  href="tel:+18888984591"
                  className="font-body text-sm text-slate-400 hover:text-orange-500 transition-colors duration-200 block"
                >
                  (888) 898-4591
                </a>
              </div>
              <div>
                <a
                  href="mailto:info@summitmoves.com"
                  className="font-body text-sm text-slate-400 hover:text-orange-500 transition-colors duration-200 block"
                >
                  info@summitmoves.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-navy-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-sm text-slate-500">
            © {new Date().getFullYear()} Summit Transport & Logistics. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="font-body text-sm text-slate-500 hover:text-slate-400 transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="font-body text-sm text-slate-500 hover:text-slate-400 transition-colors duration-200"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
